import React from "react";
import { Link } from "react-router-dom";
import { Users, Server, Target, ArrowUpRight, CheckCircle2 } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const Modeles = () => {
  const { t } = useT();

  const models = [
    { icon: Users, tag: "m1" },
    { icon: Server, tag: "m2" },
    { icon: Target, tag: "m3" },
  ];

  return (
    <div data-testid="modeles-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 hx-dot-grid opacity-50" />
        <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#1093f0]/10 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-12">
          <div className="text-xs mono uppercase tracking-[0.3em] text-[#1093f0] mb-4">{t("modelesPage.kicker")}</div>
          <h1 className="text-5xl lg:text-7xl font-semibold text-[#131517] leading-[1.02] max-w-4xl">
            {t("modelesPage.title1")} <span className="italic font-normal">{t("modelesPage.title2")}</span>
          </h1>
          <p className="mt-8 text-lg text-[#3f444b] max-w-2xl">{t("modelesPage.desc")}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12 space-y-12">
        {models.map(({ icon: Icon, tag }) => {
          const bullets = t(`modelesPage.${tag}.bullets`) || [];
          return (
            <div
              key={tag}
              className="grid lg:grid-cols-12 gap-10 bg-white border border-black/8 rounded-3xl p-10 lg:p-14 hx-card"
              data-testid={`model-${tag}`}
            >
              <div className="lg:col-span-4">
                <div className="w-14 h-14 rounded-2xl bg-[#131517] flex items-center justify-center mb-6">
                  <Icon className="w-6 h-6 text-[#1093f0]" />
                </div>
                <h2 className="text-4xl font-semibold text-[#131517] mb-4">{t(`modelesPage.${tag}.title`)}</h2>
                <p className="text-lg italic text-[#1093f0]">{t(`modelesPage.${tag}.pitch`)}</p>
              </div>
              <div className="lg:col-span-8">
                <p className="text-[#3f444b] leading-relaxed mb-8">{t(`modelesPage.${tag}.desc`)}</p>
                <ul className="grid sm:grid-cols-2 gap-3 mb-8">
                  {Array.isArray(bullets) && bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-[#1093f0] mt-0.5 shrink-0" />
                      <span className="text-sm text-[#131517]">{b}</span>
                    </li>
                  ))}
                </ul>
                <div className="text-sm text-[#6b7079] border-t border-black/5 pt-6">
                  <span className="mono text-[#1093f0]">{t("modelesPage.fitLabel")}</span>
                  {t(`modelesPage.${tag}.fit`)}
                </div>
              </div>
            </div>
          );
        })}
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-28">
        <div className="rounded-3xl bg-[#131517] text-white p-12 lg:p-16 flex flex-col lg:flex-row gap-8 items-center justify-between">
          <h3 className="text-3xl lg:text-4xl font-semibold max-w-xl">
            {t("modelesPage.ctaTitle1")} <span className="text-[#1093f0]">{t("modelesPage.ctaTitle2")}</span>
          </h3>
          <Link
            to="/contact"
            className="hx-btn-primary inline-flex items-center gap-2 bg-[#1093f0] text-white px-7 py-4 rounded-full text-sm font-semibold"
            data-testid="modeles-cta"
          >
            {t("modelesPage.ctaButton")} <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Modeles;
